import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getRegistrationStep = (state, props) => {
    const pathname = resolveProp('location.pathname', props) || resolveProp('router.location.pathname', state) || {};
    const step = pathname.match('/step([1-4])');
    return step ? parseInt(step[1], 10) : undefined;
};

export default createSelector(getRegistrationStep, (registrationStep) => registrationStep);
